module.exports = __webpack_public_path__ + "img/picture_05_portada.473c309d.png";